import { CONTACT_REQUEST } from 'constants/action-types';

export const postContact = data => ({
  type: CONTACT_REQUEST,
  payload: {
    request: {
      url: 'selling/contact',
      method: 'POST',
      headers: {
        'Cache-Control': 'no-cache'
      },
      data
    }
  }
});



// WEBPACK FOOTER //
// ./src/actions/contact/index.js